// react
import styled from 'styled-components';

// components
import { Button, Dialog, Icon } from '@/components/atoms';

/**
 * AppUpdateDialog is a popup dialog.
 */
export const AppUpdateDialog = ({
  isDialogVisible,
  onUpdate,
  setIsDialogVisible,
}: AppUpdateDialogProps) => {
  return (
    <Dialog
      title='New update available'
      description='A newer version of the app is now available. Update now for the latest features and improvements!'
      isOpen={isDialogVisible}
    >
      <Wrapper>
        <Button
          ariaLabel='Not now'
          type='button'
          variant='secondary'
          onPress={() => {
            setIsDialogVisible(false);
          }}
        >
          Not now
        </Button>
        <Button ariaLabel='refresh' type='submit' onPress={onUpdate}>
          <SpacedIcon icon='arrows-rotate' />
          Update
        </Button>
      </Wrapper>
    </Dialog>
  );
};

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
`;

const SpacedIcon = styled(Icon)`
  margin-right: 10px;
`;

interface AppUpdateDialogProps {
  isDialogVisible: boolean;
  onUpdate: () => void;
  setIsDialogVisible: (isOpen: boolean) => void;
}

AppUpdateDialog.displayName = 'AppUpdateDialog';

export default AppUpdateDialog;
